import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../scss/text.scss';
import SelectField from '../../../../shared-components/select-field/SelectField';

interface TextProperties {
  qrValues: any;
  setQrValues: React.Dispatch<React.SetStateAction<any>>;
}

/**
 * QR Text Component
 * @param {TextProperties} properties - Component properties
 * @param {any} properties.qrValues - The qrValues prop
 * @param {React.Dispatch<React.SetStateAction<any>>} properties.setQrValues - The setQrValues prop
 * @returns {JSX.Element} The Text component layout
 */
function Text({ qrValues, setQrValues }: TextProperties): JSX.Element {
  const { t } = useTranslation('qrCode');

  /**
   * Handling Font Color
   * @param {React.ChangeEvent<HTMLInputElement>} event - Change event object
   */
  const handleFontProperty = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Handling Font Weight and Size
   * @param {string} name - Property name
   * @param {string | number} value - Property value
   */
  const handleFont = (name: string, value: string | number) => {
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  const fonts = [
    {
      id: 1,
      label: t('font'),
      element: (
        <SelectField
          placeholder={t('inter')}
          options={[
            { label: t('inter'), value: 'Inter' },
            { label: t('arial'), value: 'Arial' },
            { label: t('verdana'), value: 'Verdana' },
          ]}
          selectedValue={qrValues.font}
          name="font"
          onChangeValue={handleFont}
        />
      ),
    },
    {
      id: 2,
      label: t('fontWeight'),
      element: (
        <SelectField
          placeholder={t('regular')}
          options={[
            { label: t('bold'), value: 'bold' },
            { label: t('bolder'), value: 'bolder' },
            { label: t('lighter'), value: 'lighter' },
          ]}
          selectedValue={qrValues.fontWeight}
          name="fontWeight"
          onChangeValue={handleFont}
        />
      ),
    },
    {
      id: 3,
      label: t('fontColor'),
      element: (
        <input
          onChange={handleFontProperty}
          type="color"
          name="fontColor"
          value={qrValues.fontColor}
        />
      ),
    },
  ];

  return (
    <div className="text">
      {fonts.map((font) => (
        <div key={font.id} className="text-selection">
          <div>{font.label}</div>
          <div>{font.element}</div>
        </div>
      ))}
    </div>
  );
}

export default Text;
